import { createStore, applyMiddleware } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';
import Config from '../constants/Config';

const middleware = [thunkMiddleware];

// if (process.env.NODE_ENV === 'development') {
if( !Config.RELEASE_MODE ){
    const loggerMiddleware = createLogger();
    middleware.push(loggerMiddleware);
}

export const store = createStore(
    rootReducer,
    applyMiddleware(...middleware)
);
